export default __webpack_public_path__ + "static/media/AvenirNextW04-Demi.f61a4022.woff";